import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module engine/view/typecheckable
 */
var TypeCheckable = /*#__PURE__*/function () {
  function TypeCheckable() {
    _classCallCheck(this, TypeCheckable);
  }
  _createClass(TypeCheckable, [{
    key: "is",
    value: /* istanbul ignore next -- @preserve */
    function is() {
      // There are a lot of overloads above.
      // Overriding method in derived classes remove them and only `is( type: string ): boolean` is visible which we don't want.
      // One option would be to copy them all to all classes, but that's ugly.
      // It's best when TypeScript compiler doesn't see those overloads, except the one in the top base class.
      // To overload a method, but not let the compiler see it, do after class definition:
      // `MyClass.prototype.is = function( type: string ) {...}`
      throw new Error('is() method is abstract');
    }
  }]);
  return TypeCheckable;
}();
export { TypeCheckable as default };